// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrap[data-v-17944686] {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.table-wrap .table[data-v-17944686] {\n    flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
